/*this file should be in plain JS format*/

module.exports = {
  defaultLanguage: "de",
  supportedLanguages: ["en", "de", "curacon", "dvfa", "esg", "esgen"],
};
